import React from "react";

import Modal from "../../atoms/Modal";
import qrStudentHomepage from "../../assets/images/qr_student_homepage.png";

import styles from "./StudentLoginQrCodeModal.module.scss";

export type Props = {
  onClose: () => void;
};

const StudentLoginQrCodeModal: React.FC<Props> = ({ onClose }) => {
  const loginUrl = `${process.env.REACT_APP_STUDENT_DLP_URL}/st/login`;
  return (
    <Modal onClose={onClose} className={styles.studentLoginQrCodeModal}>
      <img
        className={styles.qrCodeImage}
        src={qrStudentHomepage}
        alt="qr student homepage"
      />
      <a
        className={styles.url}
        href={loginUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {loginUrl}
      </a>
      <p className={styles.note}>
        生徒がログインID/パスワードを忘れた場合は[生徒データ]からパスワードリセットしてください。
      </p>
    </Modal>
  );
};

export default StudentLoginQrCodeModal;
